import React, { useRef } from 'react';
import { BIG_FONT_SIZE_FN, isWeb } from '../../config/designSystem/Layout';
import { COLORS, LIGHT_GRAY_FOR_TEXT } from '../../config/designSystem/Colors';
import { FontAwesome, MaterialIcons } from '@expo/vector-icons';
import { Pressable, TextInput, View } from 'react-native';
import {  mainTypoRegular } from '../../config/designSystem/typography';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';

export const MAX_WIDTH_TEXT_INPUT = 800;
export const MARGIN_HORIZONTAL_TEXT_INPUT = 25;

interface TextInputPropsBasic {
  label: string,
  value: string,
  returnKeyType: string,
  textContentType: string,
  onChangeText?: (text: string) => void,
  onBlur?: () => void,
  onSubmitEditing?: () => void,
  reference?: React.MutableRefObject<any>;
  marginTop?: number,
  marginBottom?: number,
  image?: string,
  secured?: boolean;
  autoFocus?: boolean;
  colorFrame?:string;
  widthInput?:number;
  multiline?:boolean;
  textColor?:string;
  placeholderTextColor?:string;
  keyboardType?:string;
  forceHiding?:boolean;
  marginRight?:number;
  autoComplete?:string;
  colorEvenUnfocus?:boolean;
}

interface TextInputProps extends TextInputPropsBasic {
  [key: string]: any;
}

export const TextInput2 = ({
  label,
  value,
  returnKeyType,
  secured,
  textContentType,
  autoFocus,
  colorFrame,
  image,
  textColor,
  placeholderTextColor,
  keyboardType,
  multiline,
  marginTop,
  marginBottom,
  reference,
  onChangeText,
  onBlur,
  onSubmitEditing,
  widthInput,
  rightIcon,
  marginRight,
  colorEvenUnfocus,
  forceHiding,
  autoComplete,
  ...extraArgs }: TextInputProps) => {
  const { width } = useAvailableDimensions();
  const fontSize = BIG_FONT_SIZE_FN(width);

  const internalRef = useRef<TextInput>();
  const inputRef = reference ? reference : internalRef;

  const COLOR_FRAME = colorFrame?colorFrame:COLORS.brand[500];
  const WIDTH_INPUT = widthInput? widthInput: width;
  const KEYBOARD_TYPE = keyboardType?keyboardType:'default';
  const AUTOCOMPLETE = autoComplete?autoComplete:'off';
  const TEXT_COLOR = textColor?textColor:'black';
  const PLACEHOLDER_TEXT_COLOR= placeholderTextColor?placeholderTextColor:'#00000026';
  const MARGIN_HORIZONTAL = 'marginHorizontal' in extraArgs?extraArgs.marginHorizontal:MARGIN_HORIZONTAL_TEXT_INPUT;
  const MARGIN_RIGHT= marginRight?marginRight:0;

  const WIDTH = Math.max(100, Math.min(MAX_WIDTH_TEXT_INPUT, WIDTH_INPUT)) - 2 * MARGIN_HORIZONTAL;
  const WIDTH_ICON = 40;
  const MARGIN_TOP = marginTop ? marginTop : 0;
  const MARGIN_BOTTOM = marginBottom ? marginBottom : 0;
  const SECURED = !!secured;
  const AUTO_FOCUS = !!autoFocus;
  const [showPassword, setShowPassword] = React.useState(true);
  const TEXT_CONTENT_TYPE = textContentType ? textContentType : 'none';
  const [onFocusWrapper, setOnFocusWrapper] = React.useState<any>(() => () => { });
  const [isFocus, setIsFocus] = React.useState<any>(autoFocus);
  const MULTILINE = !!multiline;

  React.useEffect(() => {
    setOnFocusWrapper(() => () => {
      setIsFocus(true);
      !!inputRef && inputRef.current.focus();
    });
  }, [inputRef]);


  const basicStyle = {
    flexDirection: 'row',
    marginHorizontal: MARGIN_HORIZONTAL,
    width: WIDTH,
    marginTop: MARGIN_TOP,
    marginBottom: MARGIN_BOTTOM,
    alignItems:'center',
    justifyContent:'center',
    padding:5,
    marginRight:50
  };

  return (
    <><Pressable
      style={(state: any) => {
        return([
          basicStyle,
          isFocus && isWeb && {
            borderWidth:2,
            borderColor: COLORS.brand[500],
          },
          !isFocus && isWeb && colorEvenUnfocus && {
            borderWidth:2,
            borderColor: COLOR_FRAME,
          },
          !isWeb && {
            borderBottomWidth: 0,
            borderBottomColor: LIGHT_GRAY_FOR_TEXT
          }
        ]);
      }}
      onFocus={onFocusWrapper}
      onPress={onFocusWrapper}
      accessibilityLabel={label}
      accessible={true}
    >
      {!!image && (
        <View style={{ width: WIDTH_ICON, alignItems: 'center' }}>
          <FontAwesome name={image} size={24} color={LIGHT_GRAY_FOR_TEXT} />
        </View>)
      }
      <TextInput
        ref={inputRef}
        placeholder={label}
        placeholderTextColor={PLACEHOLDER_TEXT_COLOR}
        style={[{
          width: '100%',
          fontFamily: mainTypoRegular,
          fontSize: fontSize,
          fontWeight: 'normal',
          fontStyle: 'normal',
          lineHeight: 1.1*fontSize,
          letterSpacing: 0.28,
          flex: 1,
          color: TEXT_COLOR,
        } as any, isWeb && { outline: 'none'}]}
        onChangeText={text => {
          !!onChangeText && onChangeText(text);
        }}
        value={value}
        textContentType={TEXT_CONTENT_TYPE as any}
        returnKeyType={returnKeyType as any}
        onSubmitEditing={onSubmitEditing}
        onBlur={() => {
          if(onBlur) {
            onBlur();
          }
          setIsFocus(false);
        }}
        autoFocus={AUTO_FOCUS}
        secureTextEntry={SECURED && (showPassword || forceHiding)}
        multiline={MULTILINE}
        numberOfLines={MULTILINE? 4 : 1}
        keyboardType={KEYBOARD_TYPE as any}
        autoComplete={AUTOCOMPLETE as any}
        {...extraArgs}
      />
      {SECURED && (
        <View style={{ width: WIDTH_ICON, alignItems: 'center',  marginRight:MARGIN_RIGHT }}>
          <MaterialIcons name={showPassword ? 'visibility' : 'visibility-off'} size={24} color={LIGHT_GRAY_FOR_TEXT} onPress={() => {
            setShowPassword(!showPassword);
          }} />
        </View>)}
      {!!rightIcon && (
        rightIcon()
      )}

    </Pressable>

    </>);
};
